import axiosApi from './common/api';

const baseAPI = 'contactus/';

class ContactUsService {

  insertItem(item: any, type: string) {
    return axiosApi.post(baseAPI, { item, "type": type });
  }

}

export default new ContactUsService();